import { PROGRESS_COLORS, getProgressVariant } from '../../utils/constants';

export interface ProgressBarProps {
  percentUsed: number;
  className?: string;
  'aria-label'?: string;
}

export function ProgressBar({
  percentUsed,
  className = '',
  'aria-label': ariaLabel,
}: ProgressBarProps) {
  const displayPercent = Math.min(percentUsed, 100);
  const variant = getProgressVariant(percentUsed);
  const { bar, bg } = PROGRESS_COLORS[variant];

  return (
    <div
      role="progressbar"
      aria-valuenow={displayPercent}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
      className={`w-24 h-3 ${bg} rounded-full overflow-hidden ${className}`}
    >
      <div
        className={`h-full ${bar} transition-all duration-300`}
        style={{ width: `${displayPercent}%` }}
      />
    </div>
  );
}
